<template>
    <flex-element :element-type="elementType" tag="ul">
        <collection-item
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :index="index"
            v-bind="element"
            :pointer="index + 1"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';
import CollectionItem from '@/components-user/dumb/containers/collection-item';

export default {
    components: { CollectionItem },
    mixins: [baseOrganism],
};
</script>
